import {
  DocumentOrganizationKeys,
  GoalFilterDocument,
  UserSettings,
} from '@griply/types';

import { defaultGoalsOverviewFilterDocument } from './constants/default-goals-overview-filter-document';

export const buildGoalsOverviewFilterDocument = (
  settings: UserSettings | undefined,
): GoalFilterDocument => {
  const stored = settings?.filters?.goalsOverview;

  return {
    ...defaultGoalsOverviewFilterDocument,
    ...(stored ?? {}),
    [DocumentOrganizationKeys.SortingMode]:
      stored?.[DocumentOrganizationKeys.SortingMode] ??
      settings?.goalSortingMode ??
      defaultGoalsOverviewFilterDocument[DocumentOrganizationKeys.SortingMode],
    [DocumentOrganizationKeys.GroupByMode]:
      stored?.[DocumentOrganizationKeys.GroupByMode] ??
      settings?.goalGroupBy ??
      defaultGoalsOverviewFilterDocument[DocumentOrganizationKeys.GroupByMode],
  };
};
